import React, { useEffect } from "react";

/**
 * AdSenseUnit - renders a Google AdSense display unit, but ONLY when the admin
 * has enabled AdSense and provided a client id + slot id (from /ads/config).
 * Renders nothing otherwise, so the app is clean until ads are configured.
 */
export default function AdSenseUnit({ config, slotKey = "landing", style }) {
  const enabled = config?.adsense_enabled;
  const client = config?.adsense_client_id;
  const slot = config?.web_slots?.[slotKey];

  useEffect(() => {
    if (!enabled || !client || !slot) return;
    if (!document.querySelector("script[data-abl-adsense]")) {
      const s = document.createElement("script");
      s.async = true;
      s.crossOrigin = "anonymous";
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
      s.setAttribute("data-abl-adsense", "1");
      document.head.appendChild(s);
    }
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      /* adsbygoogle not ready yet */
    }
  }, [enabled, client, slot]);

  if (!enabled || !client || !slot) return null;
  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block", ...style }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
      data-testid={`adsense-${slotKey}`}
    />
  );
}
